import { FontFamily } from '@common/theming/Fonts';
import { Palette } from '@common/theming/Palette';
import React from 'react';
import { AssetBlockProps } from '../../pages/AssetApp';
import { TextBlock } from '../TextBlock';

export const Timeline: React.FC<AssetBlockProps> = ({ asset }) => {
  return (
    <div style={{ width: 626 }}>
      <div style={{ marginTop: 36 }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              alignItems: 'flex-end',
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
              margin: '-18px auto 18px auto',
            }}>
            {asset.timeLine?.events.map((event, i) => {
              return (
                <div key={`timelineItemLeft-${i}`} style={{ width: 140 }}>
                  {i % 2 === 0 ? (
                    <>
                      <TextBlock
                        color={Palette.BLACK}
                        size={16}
                        style={{ marginTop: i === 0 ? 0 : 0, textAlign: 'center' }}>
                        {event.label}
                      </TextBlock>
                      <TextBlock color={Palette.BLUE} style={{ textAlign: 'center' }}>
                        {event.date}
                      </TextBlock>
                    </>
                  ) : (
                    <div
                      style={{
                        marginTop: i === 0 ? 0 : 100,
                        width: 40,
                      }}></div>
                  )}
                </div>
              );
            })}
          </div>
          <div>
            <div
              style={{
                background: 'linear-gradient(90deg, #171F2A 0%, #308EFF 100%)',
                display: 'flex',
                height: 4,
                justifyContent: 'space-between',
                margin: 'auto',
                width: ((asset.timeLine?.events.length || 0) - 1) * 140 + 1,
              }}>
              {asset.timeLine?.events.map((_, i) => {
                return (
                  <div key={`timelineDot-${i}`} style={{ height: 40 }}>
                    <div
                      style={{
                        backgroundColor: Palette.WHITE,
                        border: `2px solid ${Palette.BLUE}`,
                        borderRadius: 15,
                        height: 16,
                        marginLeft: i === 0 ? 0 : 100,
                        marginTop: -6,
                        width: 16,
                      }}></div>
                  </div>
                );
              })}
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
              margin: '-18px auto auto auto',
            }}>
            {asset.timeLine?.events.map((event, i) => {
              return (
                <div key={`timelineItemRight-${i}`} style={{ alignItems: 'flex-start', width: 140 }}>
                  {i % 2 === 1 ? (
                    <>
                      <div
                        style={{
                          color: Palette.BLACK,
                          fontFamily: FontFamily.NEUE_HAAS_DISPLAY_ROMAN,
                          fontSize: 16,
                          letterSpacing: 0.5,
                          lineHeight: 1.5,
                          marginTop: 40,
                          textAlign: 'center',
                        }}>
                        {event.label}
                      </div>
                      <div
                        style={{
                          color: Palette.BLUE,
                          fontFamily: FontFamily.NEUE_HAAS_DISPLAY_ROMAN,
                          fontSize: 12,
                          letterSpacing: 0.5,
                          lineHeight: 1.5,
                          textAlign: 'center',
                        }}>
                        {event.date}
                      </div>
                    </>
                  ) : (
                    <div
                      style={{
                        height: 40,
                        marginTop: i === 0 ? 0 : 100,
                        width: '100%',
                      }}></div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
